<template>
  <div>
    <el-form>
      <el-row :gutter="20">
        <el-col>
          <title-and-description :field="field" />
        </el-col>
        <el-col :span="12">
          <div class="form-group">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                HTML Content
                <span class="text-red-500">*</span>
              </label>
              <el-input
                type="textarea"
                v-model="field.value"
                placeholder="Enter content"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="form-group">
            <Tag :field="field" />
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import TitleAndDescription from './TitleAndDescription';
  import Tag from './Tag';

  export default {
    props: ['field'],
    components: {
      TitleAndDescription,
      Tag,
    },
    data() {
      return {};
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped></style>
